import store from '@/store'
import Role from '@/utils/role'
import localStorage from '@/services/localStorage.service'

class CredentialsService {
  setCurrentDataLogin({ user, token, institutions }) {
    this.setCurrentUser(user)
    this.setToken(token)
    this.setInstitution(institutions[0]);
    this.setInstitutions(institutions);
  }

  setCurrentUser(user) {
    store.commit('setUser', user)
    localStorage.setObject('user', user)
    localStorage.setItem('avatar', user.avatar)
    localStorage.setItem('user_account_type', user.user_account_type)
  }

  setRole(role) {
    store.commit('setRole', role)
    localStorage.setItem('role', role)
  }
  getRole() {
    return localStorage.getItem('role')
  }

  setInstitution(institution) {
    const roles = {
      1: Role.ADMIN,
      2: Role.TEACHER,
      3: Role.STUDENT,
      4: Role.ADMIN_SIS,
    }
    const role = roles[institution.roles[0].type_user_id];
    this.setRole(role)
    store.commit('setInstitution', institution)
    localStorage.setObject('institution', institution)
  }

  setInstitutions(data) {
    store.commit('setInstitutions', data)
    localStorage.setObject('institutions', data)
  }

  setToken(token) {
    localStorage.setItem('token', token)
  }

  getCurrentInstitution() {
    return localStorage.getObject('institution')
  }

  getInstitutions() {
    return localStorage.getObject('institutions')
  }

  getCurrentUser() {
    return localStorage.getObject("user")
  }

  getCurrentUserAvatar() {
    return localStorage.getItem('avatar')
  }

  getCurrentUserTipo() {
    return localStorage.getItem('user_account_type')
  }

  getToken() {
    return localStorage.getItem('token')
  }

  clearCredentials() {
    store.commit('setRole', null)
    store.commit('setUser', null)
    store.commit('setInstitution', null)
    store.commit('setInstitutions', null)
    store.commit('setEvents', [])
    localStorage.clear()
  }

  isLogin() {
    return this.getToken() !== null
  }
}

export default CredentialsService



// WEBPACK FOOTER //
// ./src/services/Credentials.service.js